module.exports = __webpack_public_path__ + "img/bin-c-4-w.01564444.svg";